var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'mobileHeight' : _vm.mobile, 'nonMobileHeight' : !_vm.mobile}},[_c('h2',{staticClass:"mt-2",staticStyle:{"text-align":"center","font-size":"18px"}},[_vm._v("Product Scan History")]),_c('div',{ref:"timelineChart",staticStyle:{"min-height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }